import loadable from '@loadable/component'

export const SubNavigation = loadable(() => import('./SubNavigation'))
export const TopNavigation = loadable(() => import('./TopNavigation'))
export const Search = loadable(() => import('./Search'))
export const SubNavigationMenu = loadable(() => import('./SubNavigationMenu'))
export type { SubNavigationProps } from './SubNavigation'
export type { TopNavigationItem, TopNavigationProps } from './TopNavigation'
